import type { ReactNode } from 'react';

interface BillingAccessGuardProps {
  children: ReactNode;
}

export const BillingAccessGuard = ({ children }: BillingAccessGuardProps) => {
  return <>{children}</>;
};
